export default __webpack_public_path__ + "static/media/(Low Res) JD Reception-014_tn.26844212.jpg";